/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Major_Loved_Wombat_EndureInputs */

const fr_major_loved_wombat_endure = /** @type {(inputs: Major_Loved_Wombat_EndureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les programmes en cycle sont des programmes sur une durée spécifiques (x semaines).`)
};

/**

* @param {Major_Loved_Wombat_EndureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const major_loved_wombat_endure = /** @type {((inputs?: Major_Loved_Wombat_EndureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Major_Loved_Wombat_EndureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_major_loved_wombat_endure(inputs)
});